module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image7_after_sale-364e54aaaefc4ea7eeef77c8a8f22253.png";